import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { apiFetch } from "@/lib/apiFetch";

export default function UserEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login");
      return;
    }

    apiFetch(`/api/users/${id}`)
      .then((res) => res.json())
      .then((data) => setUser(data));
  }, [id, isAuthenticated, navigate]);

  const handleChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await apiFetch(`/api/users/${id}`, {
      method: "PUT",
      body: JSON.stringify(user)
    });
    navigate("/users");
  };

  if (!user) return <div className="p-8">Loading...</div>;

  return (
    <div className="p-8">
      <h1 className="text-2xl font-semibold mb-6">Edit User</h1>
      <form onSubmit={handleSubmit} className="space-y-4 max-w-lg">
        <input
          type="text"
          name="name"
          value={user.name}
          onChange={handleChange}
          className="w-full p-2 border"
          placeholder="Full Name"
        />
        <input
          type="text"
          name="username"
          value={user.username}
          readOnly
          className="w-full p-2 border bg-gray-100 text-gray-700"
        />
        <input
          type="email"
          name="email"
          value={user.email}
          onChange={handleChange}
          className="w-full p-2 border"
          placeholder="Email"
        />
        <select name="status" value={user.status} onChange={handleChange} className="w-full p-2 border">
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
          <option value="pending">Pending</option>
        </select>
        <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded">
          Save Changes
        </button>
      </form>
    </div>
  );
}

